// UX101 (docs/build-briefs/UX101-console-design-review-fixes.md): the one toast slot of the software owner and
// franchisor consoles. Every short confirmation ("Copied", "Copy failed") goes here instead of an inline status line
// inside a sheet or card. The slot is a single fixed element at the bottom left of the viewport, outside the footprint
// of every centered sheet, so it never covers a sheet title or a field. The text is set with textContent only.

const TOAST_ID = "console-toast";
const SHOW_MS = 3000;

let hideTimer: number | undefined;

function slot(): HTMLElement {
  const found = document.getElementById(TOAST_ID);
  if (found !== null) return found;
  const made = document.createElement("div");
  made.id = TOAST_ID;
  made.className = "console-toast";
  made.dataset["testid"] = TOAST_ID;
  made.setAttribute("role", "status");
  made.setAttribute("aria-live", "polite");
  made.hidden = true;
  document.body.append(made);
  return made;
}

/** Shows `message` in the toast slot, replacing any earlier one, and hides it again after a few seconds. */
export function showConsoleToast(message: string): void {
  const node = slot();
  if (hideTimer !== undefined) window.clearTimeout(hideTimer);
  node.textContent = message;
  node.hidden = message === "";
  hideTimer =
    message === ""
      ? undefined
      : window.setTimeout(() => {
          node.hidden = true;
          node.textContent = "";
          hideTimer = undefined;
        }, SHOW_MS);
}

/** Empties and hides the slot (a sheet opening or closing). */
export function clearConsoleToast(): void {
  showConsoleToast("");
}
